import * as React from "react";
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import CopyDayDialog from './CopyDayDialog';
import EditDayDialog from './EditDayDialog';
import DayDeleteDialog from "./DayDeleteDialog";
import moment from "moment";
import {logger} from '../utils';


export default function BreakdownDayDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [TaskID, setTaskID] = React.useState(data.TaskID);
    const [TaskItem, setTaskItem] = React.useState([]);
    const [timeType, setTimeType] = React.useState(data.FlagType)
    const [propList, setPropListChoices] = React.useState([]);
    const [ignored, forceupdate] = React.useReducer(x => x + 1, 0);


    React.useEffect(() => {
        if (refresh) {


            logger("TaskID = " + data.TaskID + " WeekOf = " + moment.utc(data.WeekOf).format('YYYY-MM-DD'))
            fetch(`/api/Time/${data.TaskID}/${moment.utc(data.WeekOf).format('YYYY-MM-DD')}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setPropListChoices(json));

            fetch(`/api/time_prop/${data.TaskID}/${moment.utc(data.WeekOf).format('YYYY-MM-DD')}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setTaskItem(json) });

            setRefresh(false);
        }
    })

    function handleDialogCallback(childData) {
         
        let TimeEntry = {
            "ID": childData.ID,
            "RoleID": childData.RoleID,
            "TaskID": childData.TaskID,
            "WeekOf": moment.utc(data.WeekOf).format('YYYY-MM-DD'),
            "DayOf": childData.DayOf,
            "Hours": childData.Hours,
            "isFlaged": 0,
            "FlagType": childData.TimeType
        }

        logger(TimeEntry);
        fetch("api/Time_Entry", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "time_entry": TimeEntry,
                "time_entry_prop": childData.propList
            })
        })
        logger(childData);
        handleEditCallback()
        forceupdate
        setRefresh(true);
    };

    function copyCallback(childData) {
        
        fetch("/api/Time_Entry/Copy", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "time_entry": {
                    "DayOf": childData.DayOf,
                    "WeekOf": childData.WeekOf,
                    "Hours": childData.Hours,
                    "ID": childData.ID
                },
                "time_entry_prop": childData.propList
            })
        })
        logger(childData);
        handleEditCallback()
        setRefresh(true);
        forceupdate
    };

    function handleDeleteCallback(childData) {
        fetch("api/Time_Entry", {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ID: childData.ID })
        })
        logger(childData);
        handleEditCallback()
        setRefresh(true);
        forceupdate
    };

    const handleClickOpen = () => {
        setRefresh(true);
        forceupdate
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

    };

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                {data.TaskName}
            </Button>
            <Dialog open={open} onClose={handleEditCallback, handleClose} fullScreen>
                {logger(`TI`,TaskItem) }
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                            Time Breakdown
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <TableContainer component={Box}>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableCell>
                                    <h1>{"Week of " + moment.utc(data.WeekOf).format('LL')}</h1>
                                </TableCell>

                                <TableRow>
                                    <TableCell align="left">Actions</TableCell>
                                    <TableCell align="left">day</TableCell>
                                    <TableCell align="left">Task</TableCell>
                                    <TableCell align="left">Hours</TableCell>
                                    <TableCell align="left">Role</TableCell>
                                    <TableCell align="left">Task Fields</TableCell>
                                    <TableCell align="left">Flag Type</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {logger(`breakdown list`,propList)}
                                {propList.map((Day, index) => (
                                    <TableRow key={index}>
                                        <TableCell key={'Header' + Day.ID} align="left" style={{ display: "flex" }}>
                                            <EditDayDialog handleDialogCallback={handleDialogCallback} data={Day} taskFields={TaskItem.filter(item => item.timeEntryID == Day.ID)} week={moment(data.WeekOf).day("Monday").format('YYYY-MM-DD')} />
                                            <CopyDayDialog handleCopyCallback={copyCallback} data={Day} taskFields={TaskItem.filter(item => item.timeEntryID == Day.ID)} />
                                            <DayDeleteDialog handleDeleteCallback={handleDeleteCallback} data={Day}/>
                                        </TableCell>
                                        <TableCell key={'DayOf-'+Day.ID} align="left">{moment.utc(Day.DayOf).format('dddd')}</TableCell>
                                        <TableCell key={'Task-'+Day.ID} align="left">{Day.Task}</TableCell>
                                        <TableCell key={'Hours-'+Day.ID} align="left">{Day.Hours}</TableCell>
                                        <TableCell key={'Role-'+Day.ID} align="left">{Day.Role}</TableCell>
                                        <TableCell key={'Info-' + Day.ID} align="left">
                                            {TaskItem.filter(item => item.timeEntryID == Day.ID).map((item) => (<p key={'prop-' + item.ID}>
                                                {item.label}:{item.IsDropdown ? item.Name : item.Data} </p>))}</TableCell>
                                        <TableCell key={'Flag-'+Day.ID} align="left">{Day.FlagType}</TableCell>
                                    </TableRow>
                                    ))
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>
        </div>
    );
}
